module.exports = __webpack_public_path__ + "img/gucci-1.f733b272.svg";